import { TriangleAlert } from 'lucide-react';

/**
 * A2F-832: tiny inline indicator rendered next to <ScopePill> when the
 * server could not confidently determine a finding's tier (tier_confident
 * was false on the backend response).
 *
 * Reasons this can happen:
 *   - finding has no referenced documents (no_documents path)
 *   - a referenced filename is absent from the scan's document_map
 *     (unresolved_filename path)
 *
 * The finding dict carries only the boolean `tier_confident`; the reason
 * code lives in the top-level data_integrity_warnings list (used by
 * <DataIntegrityNotice>). Threading the reason here would require joining
 * findings to warnings by identity, which findings lack. A generic tooltip
 * is sufficient for this per-finding indicator; the DataIntegrityNotice
 * banner (scope-filter-independent) provides the richer per-feature context.
 */
export function TierUncertaintyIndicator() {
  const label = 'Tier could not be confidently determined';

  return (
    <span
      className="inline-flex items-center ml-1 text-amber-500"
      title={label}
      aria-label={label}
    >
      <TriangleAlert className="w-3.5 h-3.5" />
    </span>
  );
}
